import RouterSection from '@/Layout/components/RouterSection';

export default {
	path: '/',
	name: 'email',
	component: RouterSection,
	mode: 'history',
	children: [
		{
			//인증완료
			path: 'cerified',
			name: 'cerified',
			component: () => import('@/views/email/Cerified'),
		},
		{
			//수신거부
			path: 'rejectletter',
			name: 'rejectletter',
			component: () => import('@/views/email/RejectLetter'),
		},
		{
			//이메일 수신거부 신청
			path: 'emailagreeyn',
			name: 'emailagreeyn',
			component: () => import('@/views/email/EmailAgreeYn'),
		},
		{
			//이메일 수신거부 완료
			path: 'emailagreeresult',
			name: 'emailagreeresult',
			component: () => import('@/views/email/EmailAgreeResult'),
		},
	],
};
